import IQOSCommunity2022 from './IQOSCommunity2022';
export default IQOSCommunity2022;
